import { MutableRefObject, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { Branding, getBranding } from '../API/BrandingAPI'
import { ReactState } from '../Types/Types'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

export const useBranding = (): Nullable<Branding> => {
    const [branding, setBranding]: ReactState<Nullable<Branding>> = useState<Nullable<Branding>>(null)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect((): void => {
        getBranding()
            .then((brand: JSONResponse<Branding>): void => {
                if (isMounted.current) {
                    setBranding(brand)
                }
            })
            .catch((): void => {
                if (isMounted.current) {
                    setBranding({
                        LogoURL: '',
                        PrimaryColour: '',
                        TransparentLogoURL: '',
                        BroadworksLogoURL: '',
                        BroadworksName: 'Broadworks',
                        URLMapping: ''
                    })
                }
            })
    }, [])

    return branding
}
